import { selectNavigationStyleIsSubmitting } from 'api/navigationStyle'
import { selectNavigationTabsIsSubmitting } from 'api/navigationTabs'
import ConfirmModal from 'components/ConfirmModal'
import { buildTranslate } from 'locales'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { hideConfirmModal } from 'slices/Cms/Content/AppNavigation'
import { selectIsConfirmModalVisible } from 'slices/Cms/Content/AppNavigation/selectors'
import { useHandleFormSubmit } from '../../hooks'

const t = buildTranslate('cms.content.app_navigation')

export const NavConfirmModal: React.FC = () => {
  const dispatch = useDispatch()
  const isConfirmModalVisible = useSelector(selectIsConfirmModalVisible)
  const isStyleSubmitting = useSelector(selectNavigationStyleIsSubmitting)
  const isTabsSubmitting = useSelector(selectNavigationTabsIsSubmitting)
  const isFormSubmitting = isStyleSubmitting || isTabsSubmitting
  const handleSubmit = useHandleFormSubmit()

  const handlePublish = async () => {
    dispatch(hideConfirmModal())
    handleSubmit()
  }

  const handleClose = () => {
    dispatch(hideConfirmModal())
  }

  return (
    <ConfirmModal
      title={t('modal.publish_changes')}
      description={t('modal.you_are_publishing')}
      confirmText={t('modal.publish')}
      isOpen={isConfirmModalVisible}
      isLoading={isFormSubmitting}
      onClose={handleClose}
      onConfirm={handlePublish}
    />
  )
}

export default NavConfirmModal
